<template>
  <div>
    <!--banner-->
    <div class="banner"></div>
    <!--主体内容-->
    <div class="content">
      <side-nav :navs="navs" :active="active" @change-nav="changeNav">
        <side-nav-content
          :bread="['公司介绍', '公司简介']"
          v-show="active === 0"
        >
          <!--公司简介-->
          <div class="intro">
            <div class="introHead">
              <P>
                中科水研（江西）科技股份有限公司由江西省水利投资集团与中国科学院上海微系统与信息技术研究所于2019年共同组建
                ，是一家同时拥有产品及研发能力的整体解决方案提供商。公司以服务涉水行业、不断发掘生态资源为目标，规划构建成果转化产业园，以资金、技术、知识产权和产业园为纽带，通过对水产业政策与相关技术方案研究，孵化器构建、产业园建设，全面提升科技成果资源核心竞争力。<br />
                公司以突破重大产业核心技术和引领未来产业发展为目标，组织前瞻性技术和应用研发，促进新成果、新技术向涉水行业的转移转化，全面提升科技成果资源核心竞争力。
              </P>
              <img src="../assets/img/about/logo.png" />
            </div>
            <div class="introDetail">
              <div>
                <p class="blue">股东</p>
                <P>
                  中国科学院上海微系统与信息技术研究所、江西省水利投资集团、技术与管理团队。
                </P>
              </div>
              <div>
                <p class="blue">定位</p>
                <P>
                  推进国家“02科技重大专项”成果向江西落地、支撑江西“智慧水利”顺利推进，促进新成果、新技术向涉水行业的转移转化，全面提升科技成果资源的核心竞争力。
                </P>
              </div>
              <div>
                <p class="blue">性质</p>
                <P>新型研究机构，智慧水利智库，实行企业化运作。</P>
              </div>
            </div>
            <div class="business">
              <p class="title">核心业务</p>
              <div class="businessDetail">
                <div class="businessCon">
                  <div class="businessBox">
                    <img src="../assets/img/about/icon-1.png" />
                    <p>技术研发</p>
                  </div>
                  <div class="businessBox">
                    <img src="../assets/img/about/icon-2.png" />
                    <p>产业研究</p>
                  </div>
                  <div class="businessBox">
                    <img src="../assets/img/about/icon-3.png" />
                    <p>孵化器</p>
                  </div>
                  <div class="businessBox">
                    <img src="../assets/img/about/icon-4.png" />
                    <p>商务会展</p>
                  </div>
                  <div class="businessBox">
                    <img src="../assets/img/about/icon-5.png" />
                    <p>产业园</p>
                  </div>
                  <div class="businessBox">
                    <img src="../assets/img/about/icon-6.png" />
                    <p>产业基金</p>
                  </div>
                </div>
                <img src="../assets/img/about/img.png" />
              </div>
            </div>
          </div>
        </side-nav-content>
        <side-nav-content
          :bread="['公司介绍', '组织架构']"
          v-show="active === 1"
        >
          <!--组织架构-->
          <div class="framework">
            <img src="../assets/img/about/zzjg.png" />
          </div>
        </side-nav-content>
        <side-nav-content
          :bread="['公司介绍', '团队介绍']"
          v-show="active === 2"
        >
          <!--团队介绍-->
          <div class="teams">
            <div class="leaders">
              <div class="leader">
                <p class="name">张武雄</p>
                <P class="job blue">董事长</P>
                <p class="personIntro">
                  博士、研究员。长期从事蜂窝移动通信网、物联网领域研究工作，在无线网络组网、物联网安全等领域取得一系列的创新性成果。
                </p>
              </div>
              <div class="leader">
                <p class="name">许晖</p>
                <P class="job blue">技术总监</P>
                <p class="personIntro">
                  硕士、高级工程师。国家级物联网产品检验检测机构-福州物联网开放实验室创办时期的最主要领导之一。
                </p>
              </div>
            </div>
            <div class="team">
              <div class="teamName">研发团队</div>
              <div class="teamInfo">
                <P>
                  硬件研发团队：具有多年的物联网终端设计经验、低功耗优化处理经验，独立开发的超声波芯片已广泛应用于水位、流速、水表的终端上，具有“端到端”的解决能力。团队已成功将玻璃幕墙监控、水质传感器、土壤传感器、智能井盖等多种低功耗终端在线应用。
                </P>
                <p>
                  软件研发团队：团队成员在各类管理平台、大数据云平台、信息综合服务平台的建设上拥有丰富经验与成功案例。
                </P>
              </div>
            </div>
          </div>
        </side-nav-content>
      </side-nav>
    </div>
  </div>
</template>

<script>
import sideNav from "@/components/sideNav";
import SideNavContent from "@/components/sideNavContent";
export default {
  name: "about",
  components: { sideNav, SideNavContent },
  data() {
    return {
      content: ["1", "2", "3"],
      active: 0,
      navs: [
        { id: 1, name: "公司简介" },
        { id: 2, name: "组织架构" },
        { id: 3, name: "团队介绍" }
      ]
    };
  },
  methods: {
    changeNav(index) {
      this.active = index;
    }
  }
};
</script>

<style scoped>
@import "../assets/css/main.css";
.banner {
  width: 100%;
  height: 321px;
  background: url("../assets/img/about/banner.png") center no-repeat;
  margin-bottom: 40px;
}
.content {
  width: 1280px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
}
.content .right {
  width: 1000px;
}
.content .right .steps {
  display: flex;
  align-items: center;
  height: 60px;
  box-sizing: border-box;
  border-bottom: 1px solid rgba(231, 231, 231, 1);
  margin-bottom: 20px;
}
.content .right .steps p {
  font-size: 16px;
  /*color:rgba(39,39,39,1);*/
  margin-right: 15px;
}
.content .right .steps .home {
  width: 30px;
  height: 30px;
  margin-right: 15px;
}
.content .right .steps .arrow {
  width: 12px;
  height: 12px;
  margin-right: 15px;
}
.content .right .intro {
  margin-bottom: 20px;
}
.content .right .intro .introHead {
  display: flex;
  align-items:center;
}
.content .right .intro .introHead img {
  margin-left: 40px;
}
.content .right .intro .introHead p {
  font-size: 18px;
  line-height: 30px;
  width: 900px;
}
.content .right .intro .introDetail {
  padding-top: 20px;
  display: flex;
  justify-content: space-between;
  padding-bottom: 30px;
  margin-bottom: 30px;
  border-bottom: 1px solid rgba(231, 231, 231, 1);
}
.content .right .intro .introDetail div {
  width: 320px;
  box-sizing: border-box;
  padding: 20px;
  background-color: #f1f5f7;
  border-radius: 10px;
}
.content .right .intro .introDetail div p {
  font-size: 18px;
  line-height: 30px;
}
.content .right .intro .introDetail div .blue {
  font-weight: bold;
  margin-bottom: 10px;
}
.content .right .intro .business .title {
  font-size: 24px;
  font-weight: bold;
  line-height: 24px;
  margin-bottom: 20px;
}
.content .right .intro .business .businessDetail {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}
.content .right .intro .business .businessDetail .businessCon {
  display: flex;
  flex-wrap: wrap;
  width: 585px;
}
.content .right .intro .business .businessDetail .businessCon .businessBox {
  width: 150px;
  height: 170px;
  background-color: #f1f5f7;
  border-radius: 10px;
  margin-right: 25px;
  position: relative;
  text-align: center;
  margin-bottom: 30px;
}
.content .right .intro .business .businessDetail .businessCon .businessBox p {
  font-size: 20px;
  padding-top: 0px;
}
.content .right .intro .business .businessDetail .businessCon .businessBox img {
  padding: 12px;
  margin-top: 20px;
}
.content .right .framework {
  padding: 20px 0;
}
.content .right .teams {
  margin-top: 20px;
}
.content .right .teams .leaders {
  display: flex;
  justify-content: space-between;
  margin-bottom: 40px;
  border-bottom: 1px solid #f1f5f7;
  padding-bottom: 40px;
}
.content .right .teams .leaders .leader {
  width: 480px;
}
.content .right .teams .leaders .leader .name {
  font-size: 24px;
  font-weight: bold;
  color: rgba(39, 39, 39, 1);
  line-height: 40px;
}
.content .right .teams .leaders .leader .job {
  font-size: 18px;
  line-height: 40px;
}
.content .right .teams .leaders .leader .personIntro {
  font-size: 18px;
  line-height: 30px;
}
.content .right .teams .team .teamName {
  font-size: 24px;
  font-weight: bold;
  line-height: 24px;
}
.content .right .teams .team .teamInfo {
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 3px 24px 0px rgba(0, 0, 0, 0.11);
  border-radius: 10px;
  box-sizing: border-box;
  padding: 25px;
  margin: 20px 0 40px 0;
}
.content .right .teams .team .teamInfo p {
  font-size: 16px;
  line-height: 30px;
}
</style>
